import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isInternalRole } from '../lib/permissions';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, user, logout } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  // PARENT/STUDENT (yoki mid-session rol pasaytirilgan) bu panelга kira olmaydi —
  // localStorage'dan tiklangan sessiya bo'lsa ham chiqariladi (dead-end ekran o'rniga).
  if (user && !isInternalRole(user.role)) {
    logout();
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
